import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import './AddNewProCard.css'


// This is for checking that only image appears in card even if 2 images are selected as baseimg from backend
let baseImgFound = false
function AddNewProductCard(props) {


  function checkPopup(id) {
    props.selectProductIdFun(id)
    props.popupVisibility("2");
  }
  function popupUpdateFun(id, name, img,spcl,price,index) {
    let baseImg;
    {
      props.images.map((item, index) => {
        if (item.baseImage === true) {
          if (item.image.startsWith("products")) {
            baseImg = item.image
          }
          else if (item.image.startsWith("mob")) {
            baseImg = item.image
          }
          else {
            var img = item.image.substr("41")
            baseImg = img
          }
        }
      })
    }
    props.updtprofun(id, name, baseImg,spcl,price,index)
    props.otherPrice(price)
  }

  function addModal(id) {
    props.addModal(id);
    props.selectProductIdFun(id);
  }

  if (props.addModal) {
    baseImgFound = false
    return (
      <>
        <Card className="card-size text-center">

          <Card.Body className="card-padding">
            <a href="#popupDetail" className="row g-0" onClick={() => checkPopup(props.id)}>
              {props.images.map((item, index) => {

                if (item.baseImage === true && !baseImgFound) {
                  baseImgFound = true
                  if (item.image.startsWith("products")) {

                    return (
                      <>
                        <div className="add_pro_img_cntn_div">
                          <img src={"https://s3.toolsvilla.com/" + item.image} className="add_pro_img_cnt p-3" key={index} alt="img"></img>
                        </div>
                      </>
                    )
                  }
                  else if (item.image.startsWith("mob")) {

                    return (
                      <>
                        <div className="add_pro_img_cntn_div">
                          <img src={"https://s3.toolsvilla.com/" + item.image} className="add_pro_img_cnt p-3" key={index} alt="img"></img>
                        </div>
                      </>
                    )
                  }
                  else {

                    var img = item.image.substr("41")
                    return (<>
                      <div className="add_pro_img_cntn_div">
                        <img src={"https://s3.toolsvilla.com/" + img} className="add_pro_img_cnt p-3" key={img} alt="img"></img>
                      </div>
                    </>
                    )
                  }
                }
              })
              }
              <Card.Text>
                {props.productName}
              </Card.Text>
            </a>
            {props.SKU && (
  <h6
    className="sku-data"
    style={{
      color: "rgb(107, 114, 129)",
      fontFamily: "Open Sans",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: 400,
    }}
  >
    SKU : {props.SKU}
  </h6>
)}
          </Card.Body>
          <Card.Footer className="bg-none b-n">
            <button class="pushable">
              <span class="shadow"></span>
              <span class="edge"></span>
              {/* {props.vendors[0] === null ?
                  <a className="front" onClick={() => addModal(props.id)}><i class="bi bi-plus-circle"></i> Add Product</a> :
                  props.vendors[0].vActive ?<a href="#popupAddProduct" className="front"><i class="bi bi-check-circle-fill"></i> Already Added</a>: 
                  <a href="#popupAddProduct" className="front"><i class="bi bi-check-circle-fill"></i> Pending for approval</a>
                   
                } */}
              {
                props.isAllcomb ? <a className="front btn-green"><i class="bi bi-check-circle-fill"></i> Already Added</a> :
                  props.isPend ? <a className="front"><i class="bi bi-plus-circle"></i> Pending for approval</a> :
                    <a className="front" onClick={() => addModal(props.id)}><i class="bi bi-plus-circle"></i> Add Product</a>
              }


            </button>

          </Card.Footer>

        </Card>
      </>
    )
  }
  else {
     baseImgFound = false
    return (
      <>
        <Card className="card-size text-center">
          <Card.Body className="card-padding">
            <a href="#popupDetail" className="row g-0" onClick={() => checkPopup(props.id)}>
              {props.images.map((item, index) => {
               
                if (item.baseImage === true && !baseImgFound) {
                  baseImgFound = true
                  if (item.image.startsWith("products")) {

                    return (
                      <>
                        <div className="add_pro_img_cntn_div">
                          <img src={"https://s3.toolsvilla.com/" + item.image} className="add_pro_img_cnt p_3px" key={index} alt="img"></img>
                        </div>
                      </>
                    )
                  }
                  else if (item.image.startsWith("mob")) {

                    return (
                      <>
                        <div className="add_pro_img_cntn_div">
                          <img src={"https://s3.toolsvilla.com/" + item.image} className="add_pro_img_cnt p-3" key={index} alt="img"></img>
                        </div>
                      </>
                    )
                  }
                  else {

                    var img = item.image.substr("41")
                    return (<>
                      <div className="add_pro_img_cntn_div">
                        <img src={"https://s3.toolsvilla.com/" + img} className="add_pro_img_cnt p-3" key={img} alt="img"></img>
                      </div>
                    </>
                    )
                  }
                }
              })
              }
              {/* <img src={"https://s3.toolsvilla.com/" + props.img} className="w-50 p-1"></img> */}
              <Card.Text>
                {props.productName}
              </Card.Text>
            </a>
            {props.SKU && (
  <h6
    className="sku-data"
    style={{
      color: "rgb(107, 114, 129)",
      fontFamily: "Open Sans",
      fontSize: "12px",
      fontStyle: "normal",
      fontWeight: 400,
    }}
  >
    SKU : {props.SKU}
  </h6>
)}
          </Card.Body>

          <Card.Footer className="bg-none b-n">
            <button class="pushable">
              <span class="shadow"></span>
              <span class="edge"></span>
              {props.vendors[0] === null && !props.exProductReq ?
                <a href="#popupAddProduct" className="front" onClick={() => popupUpdateFun(props.lead, props.productName, props.price,"","",props.id)}><i class="bi bi-plus-circle"></i> Add Product {props.exProductReq}</a> :
                props.vendors[0] !== null && props.vendors[0].vActive ? <a href="#popupAddProduct" className="front btn-green"><i class="bi bi-check-circle-fill"></i> Already Added</a> :
                  <a href="#popupAddProduct" className="front"><i class="bi bi-check-circle-fill"></i> Pending for approval</a>

              }

            </button>
          </Card.Footer>
        </Card>
      </>
    )
  }

}

export default AddNewProductCard;